"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useField_1 = require("../../hooks/useField");
var CircleCheckM_1 = __importDefault(require("../../icons/circle-check/CircleCheckM"));
var CircleCrossM_1 = __importDefault(require("../../icons/circle-cross/CircleCrossM"));
var EyeOff_1 = __importDefault(require("../../icons/EyeOff"));
var EyeOn_1 = __importDefault(require("../../icons/EyeOn"));
var mixins_1 = require("../../style/mixins");
var TextField_1 = __importDefault(require("./TextField"));
var EyeWrapper = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 80%;\n  height: 80%;\n"], ["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 80%;\n  height: 80%;\n"])), mixins_1.normalizeButton);
var CheckIcon = styled_components_1.default(CircleCheckM_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var CrossIcon = styled_components_1.default(CircleCrossM_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var PasswordField = function (props) {
    var name = props.name, label = props.label, hint = props.hint, _a = props.hasValidationIcon, hasValidationIcon = _a === void 0 ? true : _a, trackEvent = props.trackEvent;
    var _b = react_1.default.useState(false), visible = _b[0], setVisible = _b[1];
    var toggleVisible = function () { return setVisible(function (x) { return !x; }); };
    var passedProps = { name: name, label: label, hint: hint, trackEvent: trackEvent };
    var field = useField_1.useField({ name: name });
    var _c = field[1], error = _c.error, touched = _c.touched;
    var icon = null;
    if (hasValidationIcon) {
        icon = touched ? error ? react_1.default.createElement(CrossIcon, null) : react_1.default.createElement(CheckIcon, null) : null;
    }
    else {
        icon = (react_1.default.createElement(EyeWrapper, { onClick: toggleVisible, type: "button", tabIndex: -1 }, visible ? react_1.default.createElement(EyeOn_1.default, null) : react_1.default.createElement(EyeOff_1.default, null)));
    }
    return (react_1.default.createElement(TextField_1.default, __assign({}, passedProps, { type: visible ? "text" : "password", icon: icon })));
};
exports.default = PasswordField;
var templateObject_1, templateObject_2, templateObject_3;
